"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./contracts"), exports);
__exportStar(require("./dto/save-patient-attribute-request.dto"), exports);
__exportStar(require("./dto/telecom-waiting-room.dto"), exports);
__exportStar(require("./types/start-outbound-call-attributes.types"), exports);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvYXBpLXBtcy90ZWxlY29tL2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSw4Q0FBNEI7QUFDNUIsMkVBQXlEO0FBQ3pELGlFQUErQztBQUMvQywrRUFBNkQiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgKiBmcm9tICcuL2NvbnRyYWN0cyc7XG5leHBvcnQgKiBmcm9tICcuL2R0by9zYXZlLXBhdGllbnQtYXR0cmlidXRlLXJlcXVlc3QuZHRvJztcbmV4cG9ydCAqIGZyb20gJy4vZHRvL3RlbGVjb20td2FpdGluZy1yb29tLmR0byc7XG5leHBvcnQgKiBmcm9tICcuL3R5cGVzL3N0YXJ0LW91dGJvdW5kLWNhbGwtYXR0cmlidXRlcy50eXBlcyc7XG4iXX0=